export function validateFields(state) {
    const errors = {};
    console.log("state", state)
  
    // Name validation (must be full name with one space)
    if (!state.name.trim()) {
      errors.name = "Name is required.";
    } else if (!/^[a-zA-Z]+ [a-zA-Z]+$/.test(state.name.trim())) {
      errors.name = "Please enter your full name.";
    }
  
    // Email validation
    if (!state.email.trim()) {
      errors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email.trim())) {
      errors.email = "Invalid email address.";
    }
  
    // Password validation
    const password = state.password;
  
    if (!password) {
      errors.password = "Password is required.";
    } else {
      if (password.length < 8) {
        errors.password = "Password must be at least 8 characters long.";
      }
      else if (!/[A-Z]/.test(password)) {
        errors.password = errors.password ? `${errors.password} Must include at least one uppercase letter.` : "Password must include at least one uppercase letter.";
      }
      else if (!/[a-z]/.test(password)) {
        errors.password = errors.password ? `${errors.password} Must include at least one lowercase letter.` : "Password must include at least one lowercase letter.";
      }
      else if (!/\d/.test(password)) {
        errors.password = errors.password ? `${errors.password} Must include at least one number.` : "Password must include at least one number.";
      }
      else if (!/[^A-Za-z\d]/.test(password)) {
        errors.password = errors.password ? `${errors.password} Must include at least one special character.` : "Password must include at least one special character.";
      }
    }
  
    return errors;
  }
  